import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SignatureType } from 'components/Signature/Signature';

const initialState: {
  signatureBase64: SignatureType;
} = {
  signatureBase64: null
};

export const signatureSlice = createSlice({
  name: 'signature',
  initialState,
  reducers: {
    setSignature: (
      state,
      action: PayloadAction<{
        signature: SignatureType;
      }>
    ) => {
      const { signature } = action.payload;
      state.signatureBase64 = signature;
    }
  },
  selectors: {
    getSignature: state => {
      return state.signatureBase64;
    }
  }
});

export const { setSignature } = signatureSlice.actions;
export const { getSignature } = signatureSlice.selectors;
